<template>
<div class="content-body tenant-settings">
    <div class="">
        <!-- 模具、夹具、检具成本-->
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="mini">
            <el-form-item label="工序:">
                <el-select size="mini" v-model="dataForm.process" placeholder="请选择工序" clearable @change="getDataList">
                    <el-option v-for="item in PROCESS" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="模具/夹具/检具名称:">
                <el-input size="mini" v-model="dataForm.moldFixtureCheckingToolName" placeholder="模具/夹具/检具名称" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item class="fr">
                <el-button size="mini" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
                <el-button size="mini" v-if="isAuth('sourcing:quotation:newbuttonDetail') && viewFlag !== 'view'" type="primary" plain @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建
                </el-button>
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="id" size="mini" bProject style="width: 100%" :default-expand-all="false" border :header-cell-style="{background:'#f5f5f5'}" :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="supplierName" header-align="center" align="left" label="供应商名称" width="100">
                </el-table-column>
                <el-table-column prop="roundNo" header-align="center" align="right" label="第几轮报价" width="100">
                </el-table-column>
                <el-table-column prop="process" header-align="center" align="center" label="工序" width="100">
                    <template slot-scope="scope">
                        <span>
                            {{getprocessByValue(scope.row.process)}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="moldFixtureCheckingToolName" header-align="center" align="left" label="模具/夹具/检具名称" width="150">
                </el-table-column>
                <el-table-column prop="resinDieCastingStampingDieWeight" header-align="center" align="right" label="树脂、压铸、冲压模具重量" width="180">
                </el-table-column>
                <el-table-column prop="selfMade" header-align="center" align="right" label="自制" width="100">
                </el-table-column>
                <el-table-column prop="outsourcing" header-align="center" align="right" label="外协" width="100">
                </el-table-column>
                <el-table-column prop="makingTime" header-align="center" align="right" label="制造周期" width="100">
                </el-table-column>
                <el-table-column prop="totalInvestment" header-align="center" align="right" label="总投资额" width="100">
                </el-table-column>
                <el-table-column prop="totalNumberOfTheSameMold" header-align="center" align="right" label="同种模具总数" width="100">
                </el-table-column>
                <el-table-column prop="numberPerModulus" header-align="center" align="right" label="每模取数" width="100">
                </el-table-column>
                <el-table-column prop="life" header-align="center" align="right" label="寿命" width="100">
                </el-table-column>
                <el-table-column prop="partAllocation" header-align="center" align="right" label="零件分摊" width="100">
                </el-table-column>
                <el-table-column header-align="center" align="left" width="100" label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <!--<el-button type="text" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete" class="button-danger">
                            删除
                        </el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
</div>
</template>

<script>
import {
    fetchToolsCostList,
    deleteToolsCost
} from "@/controller/quotation";
import {
    PROCESS,
    getprocessByValue
} from '@/utils/const'
import AddOrUpdate from "./quotationToolsCost-add-or-update";
import moment from "moment";
// require('@/mock/mockTech');
export default {
    data() {
        return {
            documentClientHeight: document.documentElement["clientHeight"] - 250,
            dataForm: {
                process: "",
                moldFixtureCheckingToolName: "",
            },
            viewFlag: '',
            PROCESS: PROCESS,
            getprocessByValue: getprocessByValue,
            dataList: [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false,
        };
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 265
            }
        }
    },
    components: {
        AddOrUpdate,
    },
    // mounted() {
    //     this.getDataList();
    // },
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property];
            if (date == undefined) {
                return "";
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss");
        },
        processFormat: function (value) {
            if (!value) {
                return ''
            }
            return getprocessByValue(PROCESS, value)
        },
        init(rfqId = 0, rfqPartId = 0, supplierId = 0, roundNo = 0, viewFlag) {
            this.dataForm.rfqId = rfqId
            this.dataForm.rfqPartId = rfqPartId
            this.dataForm.rfqSupplierId = supplierId
            this.dataForm.roundNo = roundNo
            this.viewFlag = viewFlag
            this.pageIndex = 1
            this.getDataList()
        },
        // 获取数据列表
        getDataList() {
            // debugger
            this.dataListLoading = true;
            fetchToolsCostList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                ...this.dataForm,
            }).then((data) => {
                // console.log(data, 'data')
                if (data && data.code === "00") {
                    this.dataList = data.body.records;
                    this.totalPage = data.body.total;
                } else {
                    this.dataList = [];
                    this.totalPage = 0;
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false;
            });
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
        },
        // 查看
        viewHandle(row) {
            let id = row ? row.id : null;
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, 'view', this.dataForm)
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            let id = row ? row.id : null;
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, 'edit', this.dataForm)
            })
        },
        // 删除
        deleteHandle(id) {
            console.log(id);

            let ids = id ? [id] :
                this.dataListSelections.map((item) => {
                    return item.id;
                });

            this.$confirm(`确定进行删除操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    deleteToolsCost(ids)
                        .then((data) => {
                            // deleteTech([id]).then((data) => {
                            if (data && data.code === "00") {
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.getDataList();
                                    },
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                })
                .catch(() => {});
        },
    },
};
</script>

<style lang="scss">
.input-width {
    width: 155px;
}

.button-danger {
    color: #F56C6C
}

.text-danger {
    color: #F56C6C
}

.text-success {
    color: #67C23A
}

.text-waming {
    color: #E6A23C;
}

.text-info {
    color: #909399;
}

.fr {
    float: right;
}
</style>
